import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/bookings").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">All bookings</h1>
      <div className="space-y-2">
        {items.map((b) => (
          <div key={b.id} className="card-tactile p-4 flex items-center justify-between gap-3 flex-wrap">
            <div>
              <div className="font-semibold text-slate-900">Booking {b.id.slice(0,8)}</div>
              <div className="text-sm text-slate-600">Job {b.job_id.slice(0,8)} · {b.job_date} · {b.start_time}–{b.end_time}</div>
            </div>
            <div className="flex items-center gap-3">
              <div className="font-display text-lg font-extrabold">£{b.gross_amount}</div>
              <StatusBadge status={b.status} />
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-500 py-10 text-center">No bookings yet.</div>}
      </div>
    </div>
  );
}
